export enum IntervaloParcelamento {
  Mensal = 'Mensal',
  MensalAntecipacao = 'MensalAntecipacao',
}
